export var reduxKey = '@@addToGroups';
export var actionKey = '@@addToGroups';
export var groupFoldersStreamType = '@@groupfolders';
export var groupsStreamType = '@@groups';
//# sourceMappingURL=constants.js.map